import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib/dist/utils';
import EmployeeFlowLayout from 'components/common/subscriber/EmployeeFlowLayout';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';
import { useIMQSubscriberDependentsPageStore } from 'store/pages/subscriber/imq/imq-subscriber-dependents/pageStore';
import SubscriberDependentsTable from 'components/common/election/SubscriberDependentsTable';
import { SUBSCRIBER_DEPENDENTS_PAGE_TEST_IDS } from 'components/subscriber/constants';
import { HEADER_SPACING_PRESETS } from '@insurancemenu/imenu-components-lib';
import { AddDependentButtonStyled, DynamicFormModalStyled } from './styles';

const PageContent: React.FC = observer(() => {
  const {
    addDependentModalStore,
    isLoading,
    dependentDelegates,
    subscriberDelegate,
    formId,
    flowDelegate,
    getInitialData,
    completeChecklistStep,
  } = useIMQSubscriberDependentsPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <EmployeeFlowLayout
      contentWidth="standard"
      flowDelegate={flowDelegate}
      pageId={SubscriberRouteV2Id.SUBSCRIBER_IMQ_SUBSCRIBER_DEPENDENTS}
      isInitialLoading={isLoading}
      pageHeader={{ spacing: HEADER_SPACING_PRESETS.withTopSectionAndActionBelow }}
      pageFooter={{
        onComplete: completeChecklistStep,
        completeButtonText: 'Complete',
        disableCompleteButton: isLoading,
      }}
    >
      <AddDependentButtonStyled
        size="large"
        color="custom"
        customColor={colors.green[600]}
        leftIconProp={<Add />}
        onClick={addDependentModalStore?.openAddDependentModal}
        data-test-id={SUBSCRIBER_DEPENDENTS_PAGE_TEST_IDS.ADD_DEPENDENT_BUTTON}
      >
        Add Dependent
      </AddDependentButtonStyled>
      {addDependentModalStore && (
        <DynamicFormModalStyled
          show={addDependentModalStore.showAddDependentModal}
          onClose={addDependentModalStore.closeAddDependentModal}
          formDelegate={addDependentModalStore.dynamicFormDelegate}
          completeButtonText="Save"
        />
      )}
      <SubscriberDependentsTable
        isLoading={isLoading}
        dependentDelegates={dependentDelegates}
        subscriberDelegate={subscriberDelegate}
        formId={formId}
      />
    </EmployeeFlowLayout>
  );
});

export default PageContent;
